import templateUrl from './conveyor.view.html'

/**
 * Conveyor detail Devices route
 *
 * @namespace routes.DevicesConveyorView
 * @type {TmrRoute}
 */
export const route = {
  name: 'devices.conveyors.view',
  label: 'DEVICES.CONVEYORS.VIEW.TITLE',
  component: 'tmrDevicesConveyorView',
  accessControl: ['Resource.view', 'Resource.Conveyor.view'],
  abstract: false,
}

/**
 * Component for {@link routes.tmrDevicesConveyorView Conveyor Details route}
 *
 * @type {ngComponent}
 */
export const tmrDevicesConveyorView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrDevicesConveyorViewController',
  bindings: {
    resource: '<',
  },
}

/**
 * Controller of component {@link tmrDevicesConveyorView}.
 *
 * @type {ngController}
 */
export class tmrDevicesConveyorViewController {
  static ngType = 'controller'

  $onInit() {
    this.details = [
      { label: 'DEVICES.CONVEYORS.VIEW.ID', value: this.resource.id },
      {
        label: 'RESOURCELIST.CREATIONDATEFILTER',
        value: this.resource.creationDate,
        filter: 'tmrDate',
      },
      {
        label: 'RESOURCELIST.LASTMODIFIEDFILTER',
        value: this.resource.lastModified,
        filter: 'tmrDate',
      },
      { label: 'DEVICES.CONVEYORS.VIEW.CODE', value: this.resource.code },
      {
        label: 'DEVICES.CONVEYORS.VIEW.DESCRIPTION',
        value: this.resource.description,
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.TYPE',
        value: this.resource.$getTypeDescription(),
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.CONTROLLER',
        value: this.resource.deviceController.$getLabel(),
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.PLACE',
        value: this.resource.place.$getLabel(),
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.CONVEYORUSER',
        value: this.resource.conveyorUser.$getLabel(),
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.AUTOSTART',
        value: this.resource.autostart,
        filter: 'tmrBoolean',
      },
      {
        label: 'DEVICES.CONVEYORS.VIEW.CONVEYORMODE',
        value: this.resource.conveyorMode,
      },
    ]
    if (this.resource.type == 'TmrImpinjConveyorDto') {
      if (this.resource.barcodeReader)
        this.details.push({
          label: 'DEVICES.CONVEYORS.VIEW.BARCODEREADER',
          value: this.resource.barcodeReader.$getLabel(),
        })
      this.details.push({
        label: 'DEVICES.CONVEYORS.VIEW.READER',
        value: this.resource.rfidReader.$getLabel(),
      })
      this.details.push({
        label: 'DEVICES.CONVEYORS.VIEW.PREVIOUSEPCSTTL',
        value: this.resource.previousEpcsTTL,
      })
    }
  }
}
